import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('adminToken');
};

// Admin Auth API
export const adminLogin = async (password) => {
  const response = await axios.post(`${API}/admin/login`, { password });
  localStorage.setItem('adminToken', response.data.token);
  return response.data;
};

export const adminLogout = async () => {
  const token = getAuthToken();
  if (token) {
    try {
      await axios.post(`${API}/admin/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  }
  localStorage.removeItem('adminToken');
};

// Admin Bookings API
export const getAllBookings = async (filters = {}) => {
  const token = getAuthToken();
  const params = new URLSearchParams(filters).toString();
  const response = await axios.get(`${API}/admin/bookings?${params}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const getDashboardStats = async () => {
  const token = getAuthToken();
  const response = await axios.get(`${API}/admin/dashboard/stats`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const createManualBooking = async (bookingData) => {
  const token = getAuthToken();
  const response = await axios.post(`${API}/admin/bookings/manual`, bookingData, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const updateBooking = async (bookingId, updates) => {
  const token = getAuthToken();
  const params = new URLSearchParams(updates).toString();
  const response = await axios.patch(`${API}/admin/bookings/${bookingId}?${params}`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const deleteBooking = async (bookingId) => {
  const token = getAuthToken();
  const response = await axios.delete(`${API}/admin/bookings/${bookingId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Admin Customers API
export const getAllCustomers = async () => {
  const token = getAuthToken();
  const response = await axios.get(`${API}/admin/customers`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Admin Availability API
export const updateAvailability = async (date, timeSlots) => {
  const token = getAuthToken();
  const response = await axios.put(`${API}/admin/availability/${date}`, 
    { date, timeSlots },
    { headers: { Authorization: `Bearer ${token}` }}
  );
  return response.data;
};

export const getCustomAvailability = async (date) => {
  const token = getAuthToken();
  const response = await axios.get(`${API}/admin/availability/${date}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};
